(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  /*
    ============================================================
    SCRIPT COMPLET (v4)
    - Gère les clics sur les flèches
    - Gère la mise à jour du compteur
    - Gère l'autoplay
    ============================================================
  */
  (function(){
    const root = document.currentScript.closest('section');
    if(!root) return;
    const comp = root.querySelector('slider-component');
    if(!comp) return;
    
    const list = root.querySelector('#GminSlider-{{ section.id }}');
    if(!list) return;
    
    const slides = Array.from(list.querySelectorAll('.slider__slide'));
    if(slides.length === 0) return;

    const btnPrev = root.querySelector('#gmin-prev-{{ section.id }}');
    const btnNext = root.querySelector('#gmin-next-{{ section.id }}');
    const curEl  = root.querySelector('#gmin-current-{{ section.id }}');
    const totEl  = root.querySelector('#gmin-total-{{ section.id }}');

    const autoplay = comp.getAttribute('data-autoplay') === 'true';
    const speedSec = parseInt(comp.getAttribute('data-speed') || '5', 10);
    let timer;
    
    if(totEl) totEl.textContent = slides.length.toString();

    function stepWidth(){
      const s = slides[0];
      const style = window.getComputedStyle(list);
      const gap = parseFloat(style.columnGap || style.gap || '12');
      return s.offsetWidth + gap;
    }

    function scrollToIndex(i){
      const w = stepWidth();
      list.scrollTo({ left: i * w, behavior: 'smooth' });
    }

    function activeIndex(){
      const w = stepWidth();
      if(w <= 0) return 0;
      return Math.round(list.scrollLeft / w);
    }

    function updateCounter(){
      if(!curEl) return;
      const i = Math.min(activeIndex(), slides.length - 1);
      curEl.textContent = (i + 1).toString();
    }

    // --- Clics sur les flèches ---
    if(btnPrev){
      btnPrev.addEventListener('click', function(){
        const i = Math.max(activeIndex() - 1, 0);
        scrollToIndex(i);
        stop();
      });
    }
    if(btnNext){
      btnNext.addEventListener('click', function(){
        const i = Math.min(activeIndex() + 1, slides.length - 1);
        scrollToIndex(i);
        stop();
      });
    }

    // --- Autoplay ---
    const start = () => {
      if(!autoplay) return;
      stop(); 
      timer = setInterval(() => {
        let i = activeIndex() + 1;
        if (i >= slides.length) i = 0;
        scrollToIndex(i);
      }, Math.max(3, speedSec) * 1000); 
    };
    const stop = () => { if(timer) clearInterval(timer); };

    comp.addEventListener('mouseenter', stop);
    comp.addEventListener('mouseleave', start);
    comp.addEventListener('focusin', stop);
    comp.addEventListener('focusout', start);
    
    list.addEventListener('scroll', () => { window.requestAnimationFrame(updateCounter); }, { passive:true });
    window.addEventListener('resize', () => { window.requestAnimationFrame(updateCounter); });

    start();
    updateCounter();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nouveautes-slider"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const root = document.currentScript.closest('section');
    if(!root) return;
    const comp = root.querySelector('slider-component');
    if(!comp) return;
    const autoplay = comp.getAttribute('data-autoplay') === 'true';
    const speedSec = parseInt(comp.getAttribute('data-speed') || '5', 10);
    if(!autoplay) return;
    const nextBtn = comp.querySelector('.slider-button--next');
    if(!nextBtn) return;
    let timer;
    const start = () => { stop(); timer = setInterval(() => { nextBtn.click(); }, Math.max(3, speedSec) * 1000); };
    const stop = () => { if(timer) clearInterval(timer); };
    const io = new IntersectionObserver((entries)=>{ entries.forEach(e => { if(e.isIntersecting){ start(); } else { stop(); } }); }, { threshold: 0.2 });
    io.observe(comp);
    comp.addEventListener('mouseenter', stop);
    comp.addEventListener('mouseleave', start);
    comp.addEventListener('focusin', stop);
    comp.addEventListener('focusout', start);
    start();
  })();

  } catch(e) { console.error(e); }
})();
})();
